// Module
var code = "<ng-include class=\"hidden-xs\" ng-if=\"!viewConfig.hideListHeader\" src=\"'common/listHeaderColumns.tpl.html'\"></ng-include>\n";
// Exports
module.exports = code;